import React from 'react';
import { useTheme } from 'styled-components';
import { Select } from 'components/FormFields';
import Images from 'images';
import {
  PanelWrapper,
  Panel,
  PanelBrand,
  PanelBrandLogo,
  PanelCloseButton,
  CollapseIcon,
  CollapseBar,
  CollapseArrow,
  PanelAccountRow,
  PanelHeader,
  PanelTitle,
  PanelBody,
  PanelExpandButton,
} from '../styled/SidePanel.styled';
import PanelSection from './PanelSection';

const platform = process.env.REACT_APP_PLATFORM;

const getPanelLogo = (isLight) => {
  if (platform === 'tickethoss') return Images.ticketHossOneLine;
  if (platform === 'kartpass') return Images.logoKartPassHorizontal;
  if (isLight) return Images.logoHorizontalOrange;
  return Images.logoHorizontalWhite;
};

const SidePanel = ({
  isOpen,
  activeSection,
  sections,
  onClose,
  onOpen,
  // Account selector props
  showAccountSelector,
  account,
  accountOptions,
  onAccountChange,
  // Action handlers
  onStripeClick,
  onPermissionDenied,
}) => {
  const theme = useTheme();
  const isLight = theme?.name === 'light';
  const currentSection = sections.find((s) => s.id === activeSection);

  return (
    <>
      <PanelWrapper isOpen={isOpen}>
        <Panel>
          <PanelBrand>
            <PanelBrandLogo src={getPanelLogo(isLight)} alt={platform} />
            <PanelCloseButton onClick={onClose} title="Collapse panel">
              <CollapseIcon>
                <CollapseBar />
                <CollapseBar />
                <CollapseBar />
                <CollapseArrow />
              </CollapseIcon>
            </PanelCloseButton>
          </PanelBrand>

          {showAccountSelector && (
            <PanelAccountRow>
              <Select
                placeholder="Select Account"
                value={account?.value ?? ''}
                onChange={(e) => {
                  const selected = (accountOptions || []).find(
                    (o) => String(o.value) === e.target.value
                  );
                  if (selected) onAccountChange(selected);
                }}
                options={accountOptions || []}
              />
            </PanelAccountRow>
          )}

          {currentSection && currentSection.panelItems && (
            <>
              <PanelHeader>
                <PanelTitle>
                  {currentSection.panelTitle || currentSection.label}
                </PanelTitle>
              </PanelHeader>
              <PanelBody>
                <PanelSection
                  items={currentSection.panelItems}
                  onStripeClick={onStripeClick}
                  onPermissionDenied={onPermissionDenied}
                />
              </PanelBody>
            </>
          )}
        </Panel>
      </PanelWrapper>

      {!isOpen && (
        <PanelExpandButton onClick={onOpen} title="Expand panel">
          <CollapseIcon>
            <CollapseBar />
            <CollapseBar style={{ width: 12 }} />
            <CollapseBar style={{ width: 16 }} />
            <CollapseArrow
              style={{
                right: 'auto',
                left: -1,
                borderRight: 'none',
                borderLeft: '5px solid currentColor',
              }}
            />
          </CollapseIcon>
        </PanelExpandButton>
      )}
    </>
  );
};

export default SidePanel;
